import { CreateThreadBody, CreateTopicBody, ForumService } from '@/app/services/ForumService'
import { layoutActions } from '@Techedge/digitalportal-shared'
import { Dispatch } from 'redux'

export const ForumAction = {
    CREATE_FORUM_SUCCESS: 'CREATE_FORUM_SUCCESS',
    CREATE_FORUM_FAILURE: 'CREATE_FORUM_FAILURE',
}

export const createForumSuccess = (text) => {
    return {
        type: ForumAction.CREATE_FORUM_SUCCESS,
        toastList: [
            {
                text,
            },
        ],
    }
}
export const createForumFailure = (text) => {
    return {
        type: ForumAction.CREATE_FORUM_FAILURE,
        toastList: [
            {
                text,
            },
        ],
    }
}

// THREAD
export const createThread = (body: CreateThreadBody, successMessage: string) => {
    return (dispatch: Dispatch) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ForumService.CreateThread(body)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(createForumSuccess(successMessage))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false },
                        })
                    )
                } else {
                    dispatch(createForumFailure(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(createForumFailure(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}
export const editThread = (body: CreateThreadBody, successMessage: string) => {
    return (dispatch: Dispatch) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ForumService.EditThread(body)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(createForumSuccess(successMessage))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false },
                        })
                    )
                } else {
                    dispatch(createForumFailure(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(createForumFailure(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}

// TOPIC
export const createTopic = (body: CreateTopicBody, successMessage: string) => {
    return (dispatch: Dispatch) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ForumService.CreateTopic(body)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(createForumSuccess(successMessage))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false },
                        })
                    )
                } else {
                    dispatch(createForumFailure(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(createForumFailure(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}
export const editTopic = (body: CreateTopicBody, successMessage: string) => {
    return (dispatch: Dispatch) => {
        dispatch(layoutActions.setModals({ props: { loading: true } }))
        ForumService.EditTopic(body)
            .then((res) => {
                if (res && res.data && !res.data.output) {
                    dispatch(createForumSuccess(successMessage))
                    dispatch(
                        layoutActions.setModals({
                            type: null,
                            props: { id: null, loading: false },
                        })
                    )
                } else {
                    dispatch(createForumFailure(res.data.output.payload.message))
                }
            })
            .catch((error: any) => {
                dispatch(createForumFailure(error.response?.data?.message || error.message))
                dispatch(layoutActions.setModals({ props: { loading: false } }))
            })
    }
}